import React from 'react'

import FormError from "../../../gd-form/common/form-error/form-error"
import FormRowFlex from "../../../gd-form/form/form-flex/row"
import {CustomFieldScope} from "../../../model2/custom-field/@const"
import FieldFormElement from "../../../fields3/render/form-elemnent"

type Props = {
    form            : any
    mandatoryScope  : CustomFieldScope[]
}

export default function CustomField_FromRowScope(props:Props) {

    const field = gd.fields.customFieldParams.scope

    return (
        <FormRowFlex field={field}>
            <div className="flex-column-left-top">
                <FieldFormElement className = "w-300"
                                  field     = {field}
                                  form      = {props.form}/>
                <FormError form = {props.form}
                           name = {field.fieldId} />
            </div>
        </FormRowFlex>
    )
}
